export const backofficeColors = {
    primary_color: "#7792B1",
    secondary_color: "#6993FF",
    tertiary_color: "#ddd"
  }